"use client";
import { IoIosStar } from "react-icons/io";
import { MdMedicalServices } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import Slider, { Settings } from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Doctorbox() {
  const settings: Settings = {
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const menu = [
    // {
    //   name: "Dr. D Vijaya Meenakshi",
    //   dis: (
    //     <h6 className="pt-2 font-medium">
    //       MBBS, MD -<br></br> Obstetrics & Gynaecology
    //     </h6>
    //   ),
    //   img: "../photo/doc1.jpg",
    //   rate: "",
    //   exper: "20",
    //   depat: "Obstetrics and Gynecology",
    // },
    {
      name: "Dr. Ajay S S",
      dis: (
        <h6 className="pt-2 font-medium">
          MS -<br></br> Orthopaedics, MBBS
        </h6>
      ),
      img: "../photo/doc15.jpg",
      rate: "",
      exper: "6",
      depat: "Orthopedic",
      timings: "MON TO FRI - 7:30 PM ON APPT",
    },
    // {
    //   name: "Dr. SACHIN PATIL ",
    //   dis: (
    //     <h6 className="pt-2 font-medium">
    //       M. S. GENERAL SURGERY<br></br> M.B.B.S. (2009 – 2015)
    //     </h6>
    //   ),
    //   img: "../photo/doc3.jpg",
    //   rate: "",
    //   exper: "5",
    //   depat: "General Surgery",
    // },
    // {
    //   name: "Dr. Sainath T V",
    //   dis: (
    //     <h6 className="pt-2 font-medium">
    //       MBBS, DCH, DNB PED, Fellowship in Neonatology, NNF
    //     </h6>
    //   ),
    //   img: "../photo/doc4.jpg",
    //   rate: "",
    //   exper: "7",
    //   depat: "Neonatologist & Pediatrician",
    // },
    // {
    //   name: "Dr. N.S Santhosh",
    //   dis: (
    //     <h6 className="pt-2 font-medium">
    //       MBBS<br></br> DNB-Neurology
    //     </h6>
    //   ),
    //   img: "../photo/doc5.jpg",
    //   rate: "",
    //   exper: "21",
    //   depat: "Neurologist",
    // },

    // {
    //   name: "Dr. Pruthviraj MO",
    //   dis: (
    //     <h6 className="pt-2 font-medium">
    //       MBBS, DNB - OBG<br></br> PGDip-Ultrasonography
    //     </h6>
    //   ),
    //   img: "../photo/doc6.jpg",
    //   rate: "",
    //   exper: "10",
    //   depat: "Obstetrics and Gynecology",
    // },
    {
      name: "Dr. Lipika Debbarma",
      dis: (
        <h6 className="pt-2 font-medium">
          MBBS, DFM(RCGP,UK), <br></br> PGDCD
        </h6>
      ),
      img: "../photo/dr-lipika-debbarma.jpg",
      rate: "4.6",
      exper: "16",
      depat: "Cosmetology & Aesthetic Dermatology",
      timings: "MON TO SAT - ON APPOINTMENT",
      link: "/bestdermatologytreatmentsinwhitefield-by-dr-lipika-debbarma",
    },
    // {
    //   name: "Dr. Razia Sultana",
    //   dis: (
    //     <h6 className="pt-2 font-medium">
    //       MBBS, DLO <br></br> (ENT)
    //     </h6>
    //   ),
    //   img: "../photo/doc8.jpg",
    //   rate: "",
    //   exper: "5",
    //   depat: "ENT Speialist",
    // },
    // {
    //   name: "Dr. Vijyanta Suman",
    //   dis: (
    //     <h6 className="pt-2 font-medium">
    //       BDS, MDS
    //       <br></br> Prostho dentist
    //     </h6>
    //   ),
    //   img: "../photo/doc9.jpg",
    //   rate: "",
    //   exper: "5",
    //   depat: "Prostho dentist",
    // },
    {
      name: "Dr. Anirban Bhowmik",
      dis: (
        <h6 className="pt-2 font-medium">
          MBBS
          <br></br> (PGDCC), (PGDD)
        </h6>
      ),
      img: "../photo/doc10.jpg",
      rate: "",
      exper: "5",
      depat: "Cardiologist",
      timings: "8:00 AM & 5:00 PM ON APPT",
    },
    // {
    //   name: "Dr. Lokesh Gowda T G",
    //   dis: (
    //     <h6 className="pt-2 font-medium">
    //       MBBS, MS, MCh (Urology)
    //       <br></br>
    //       Urologist
    //     </h6>
    //   ),
    //   img: "../photo/doc11.jpg",
    //   rate: "",
    //   exper: "5",
    //   depat: "Urology",
    // },
    // {
    //   name: "Ms. Jeeveetha Ragupathy",
    //   dis: (
    //     <h6 className="pt-2 font-medium">
    //       Dietitian
    //       <br></br>& Nutritionist
    //     </h6>
    //   ),
    //   img: "../photo/doc12.jpg",
    //   rate: "",
    //   exper: "5",
    //   depat: "Dietitian & Nutritionist",
    // },
    {
      name: "Mr. Naveen Kodandaram",
      dis: (
        <h6 className="pt-2 font-medium">
          Dietitian
          <br></br>& Nutritionist
        </h6>
      ),
      img: "../photo/doc13.jpg",
      rate: "",
      exper: "5",
      depat: "Dietitian & Nutritionist",
      timings: "ON APPT",
    },
    {
      name: "Dr. Binila",
      dis: (
        <h6 className="pt-2 font-medium">
          BPT, MIAP
          <br></br>
          Physiotherapist
        </h6>
      ),
      img: "../photo/doc14.jpg",
      rate: "",
      exper: "20",
      depat: "Physiotherapist",
      timings: "MON TO SAT - 8:00 AM TO 6:00 PM",
    },
    // {
    //   name: "Dr Ajay S S",
    //   dis: (
    //     <h6 className="pt-2 font-medium">
    //       MBBS, MS (Orthopaedics)
    //       <br></br>FJR, FSCRM Orthopaedic Surgeon
    //     </h6>
    //   ),
    //   img: "../photo/doc15.jpg",
    //   rate: "",
    //   exper: "5",
    //   depat: "Orthopaedic Surgeon",
    // },
    // {
    //   name: "Dr Pavithra",
    //   dis: (
    //     <h6 className="pt-2 font-medium">
    //       MBBS
    //       <br></br>--
    //     </h6>
    //   ),
    //   img: "../photo/doc16.jpg",
    //   rate: "",
    //   exper: "5",
    //   depat: "--",
    // },

    // {
    //   name: "Dr - vishnuvardhan BR",
    //   dis: (
    //     <h6 className="pt-2 font-medium">
    //       MBBS, MD, general medicine <br></br>DM Nephrology Renal specialist
    //     </h6>
    //   ),
    //   img: "../photo/doc2.jpg",
    //   rate: "",
    //   exper: "5",
    //   depat: "Nephrologist",
    // },
    // {
    //   name: "Dr. Chandrika Chandran",
    //   dis: (
    //     <h6 className="pt-2 font-medium">
    //       MBBS, DGO <br></br>Gynecologist and Obstetrician
    //     </h6>
    //   ),
    //   img: "../photo/02-04-24.jpg",
    //   rate: "",
    //   exper: "50",
    //   depat: "Gynecologist and Obstetrician",
    // },

    {
      name: "Dr. Shalini Kumari",
      dis: (
        <h6 className="pt-2 font-medium">
          MBBS, MS( OBG ),<br></br>Fellowship (RGUHS), MRCOG
        </h6>
      ),
      img: "../photo/dr-shalini-kumari.png",
      rate: "",
      exper: "11",
      depat: "Gynecologist and Obstetrician",
      timings: "MON - SAT - 10:30 AM TO 12:30 PM",
    },
    // {
    //   name: "Dr. Kirti S",
    //   dis: <h6 className="pt-2 font-medium">MBBS, MS Otorhinolaryngology</h6>,
    //   img: "/photo/dr-kirti.png",
    //   rate: "",
    //   exper: "11",
    //   depat: "ENT Surgeon",
    // },
    // {
    //   name: "Dr. Vineesh Sukumaran",
    //   dis: (
    //     <h6 className="pt-2 font-medium" style={{ fontSize: "0.8rem" }}>
    //       MBBS,Fellowship(Internal Medicine) PGDiploma in Psychology of Mental
    //       Health,Fellowship in Diabetology
    //     </h6>
    //   ),
    //   img: "/doctor-images/Dr-Vineesh-Sukumaran.jpg",
    //   rate: "",
    //   exper: "14",
    //   depat: "General Physician",
    //   timings: "MON TO SAT - 10 AM TO 8:30 PM & 24/7",
    // },
    {
      name: "Dr. Shaik Salman Basha",
      dis: <h6 className="pt-2 font-medium">BDS, MDS, (Prosthodontics)</h6>,
      img: "/doctor-images/Dr. Shaik Salman Basha.jpg",
      rate: "",
      exper: "10",
      depat: "Dentistry",
      timings: "MON TO SAT - 10:00 AM TO 8:00 PM",
    },
    // {
    //   name: "Dr. Anamika Chanda Bhowmik",
    //   dis: <h6 className="pt-2 font-medium">MBBS, MS - ENT</h6>,
    //   img: "/doctor-images/Dr. Anamika Ch Bhowmik.jpeg",
    //   rate: "",
    //   exper: "12",
    //   depat: "ENT Specialist",
    //   timings: "MON TO SAT - 5 PM TO 7 PM",
    // },
    {
      name: "Dr. Anirudh Rao",
      dis: <h6 className="pt-2 font-medium">MBBS, MS</h6>,
      img: "/doctor-images/Dr. Anirudh S Rao.jpg",
      rate: "",
      exper: "12",
      depat: "Orthopedic Surgeon",
      timings: "MON TO SAT - 5 PM TO 6:30 PM",
    },
    {
      name: "Dr. Sachin Patil",
      dis: <h6 className="pt-2 font-medium">M.S. GENERAL SURGERY M.B.B.S.</h6>,
      img: "/doctor-images/Dr Sachin Patil.jpg",
      rate: "",
      exper: "5",
      depat: "General Surgeon",
      timings: "MON TO SAT - 5:30 PM ON APPT",
    },
    {
      name: "Dr. Sumeeta Nagaraj",
      dis: <h6 className="pt-2 font-medium">MBBS, DCH, DNB</h6>,
      img: "/doctor-images/Dr. Sumeeta Nagaraj.webp",
      rate: "",
      exper: "27",
      depat: "Pediatrician",
      timings: "MON - SAT - 7:30 PM",
    },
    {
      name: "Dr. Manjunatha BG",
      dis: <h6 className="pt-2 font-medium">MBBS, MD, DM, EDRM</h6>,
      img: "/doctor-images/Dr. Manjunath B G.webp",
      rate: "",
      exper: "16",
      depat: "Pulmonologist",
      timings: "FRIDAY - 7 TO 8 PM",
    },
    // {
    //   name: "Dr. Santosh K",
    //   dis: (
    //     <h6 className="pt-2 font-medium">
    //       M.Ch Urology (Gold Medalist), M.S. Surgery, M.B.B.S
    //     </h6>
    //   ),
    //   img: "/doctor-images/Dr. Santosh K.jpg",
    //   rate: "",
    //   exper: "10",
    //   depat: "Urologist",
    //   timings: "MON TO SAT - ON APPOINTMENT",
    // },
    {
      name: "Dr. Pragati Shatapathy",
      dis: (
        <h6 className="pt-2 font-medium">
          Audiologist, Speech-Language Pathologist & Vestibular Rehabilitation
          TherapistS
        </h6>
      ),
      img: "/doctor-images/Dr-Pragati.jpg",
      rate: "",
      exper: "17",
      depat: "Pathologist",
      timings: "MON TO SAT - ON APPOINTMENT",
    },

    {
      name: "Dr. Manika Teotia",
      dis: (
        <h6 className="pt-2 font-medium">
          ENT Consultant | Endoscopic Ear Surgeries & PRP Therapy
          (SNHL/Tinnitus)
        </h6>
      ),
      img: "/doctor-images/Dr-Manika-Teotia.jpg",
      rate: "",
      exper: "7",
      depat: "ENT",
      timings: "MON TO SAT - ON APPOINTMENT",
    },
    {
      name: "Dr. Raghavendra Telang",
      dis: (
        <h6 className="pt-2 font-medium">
          General Physician (MBBS) | Medical Officer | ICU & Emergency Care
        </h6>
      ),
      img: "/doctor-images/Dr-Raghavendra-Telang.jpg",
      rate: "",
      exper: "1",
      depat: "General Medicine",
      timings: "MON TO SAT - ON APPOINTMENT",
    },

    // {
    //   name: "Dr. Abdul Aziz Riyaz",
    //   dis: (
    //     <h6 className="pt-2 font-medium">
    //       MBBS, MS - General Surgery, MCh - Neuro Surgery
    //     </h6>
    //   ),
    //   img: "/doctor-images/Dr. Abdul Aziz Riyaz.webp",
    //   rate: "",
    //   exper: "13",
    //   depat: "Neurosurgeon",
    //   timings: "FRI - 10 AM to 11 AM",
    // },
  ];
  return (
    <>
      <section className="flex justify-center pb-8 pt-0">
        <div className="containerbox">
          {/* <h1
            style={{
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
            }}
            className="text-3xl font-bold leading-snug"
          >
            Our Esteemed Doctors
          </h1> */}
          {/* <div className="w-full flex justify-center">
            <h6 className="text-xl font-medium mb-3">Our Esteemed Doctors</h6>
          </div> */}
          <div className="col-span-2 flex items-center mt-4">
            <div className="px-0 overflow-hidden">
              <Slider {...settings}>
                {menu.map((elem) => {
                  return (
                    <>
                      <div className="w-full p-2 flex">
                        <div className="w-full rounded-lg bg-white">
                          <div className="flex flex-wrap  shadow-sm rounded-md p-4 relative w-full">
                            <div className="w-1/5">
                              <img
                                className="rounded-md w-full h-24 object-cover object-top "
                                src={elem.img}
                                alt=""
                              />
                            </div>
                            <div className="w-4/5 md:w-2/3 pl-2">
                              <h6
                                style={{ color: "#3d7cc9" }}
                                className="font-medium"
                              >
                                {elem.name}
                              </h6>
                              {elem.dis}
                            </div>
                            <div className="w-full mt-3 flex">
                              <div className="w-1/3 flex items-center">
                                <IoIosStar />
                                <h6 className="text-gray-600 ml-1 md:ml-2 text-sm">
                                  4.6/5
                                </h6>
                              </div>
                              <div className="w-1/3 flex items-center">
                                <MdMedicalServices />
                                <h6 className="text-gray-600 ml-1 md:ml-2 text-sm">
                                  {`${elem.exper}+ Years`}
                                </h6>
                              </div>
                              <div className="w-1/3 flex items-center">
                                <FaLocationDot />
                                <h6 className="text-gray-600 ml-1 md:ml-2 text-sm">
                                  Bangalore
                                </h6>
                              </div>
                            </div>
                            <button className="border-inherit border py-1 px-3 rounded-md mt-3 text-white bg-gray-400 text-sm">
                              {elem.depat}
                            </button>
                            {elem.timings && (
                              <button className="border-inherit border py-1 px-3 rounded-md mt-3 text-white bg-gray-400 text-sm">
                                {elem.timings}
                              </button>
                            )}
                            <div className="w-full mt-4 flex justify-between">
                              <div className="w-5/12 pr-3">
                                <a
                                  href="tel:9535264855"
                                  style={{ border: "1.5px solid #3d7cc9" }}
                                  className="border-inherit border-2 text-black p-1 rounded-md w-full hidden md:flex justify-center text-sm"
                                >
                                  9535264855
                                </a>
                                <a
                                  className="border-inherit border-2 text-black p-1 rounded-md w-full flex justify-center md:hidden text-sm"
                                  href="tel:9535264855"
                                >
                                  Call Us
                                </a>
                              </div>
                              <div className="w-7/12">
                                <div className="flex w-full">
                                  <a
                                    href="tel:9535264855"
                                    style={{ backgroundColor: "#3d7cc9" }}
                                    className="border-inherit border py-1 px-3 rounded-md text-white w-full text-sm text-center h-full"
                                  >
                                    Appointment
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </Slider>
            </div>
          </div>
          {/* <div className="w-full justify-center">
            <div className="flex justify-center mt-4">
              <button
                style={{ backgroundColor: "#3d7cc9" }}
                className="border-inherit border py-1 px-4 rounded-md mt-4 text-white flex items-center mr-2 mr-"
              >
                Book Appointment
              </button>
              <button
                style={{ backgroundColor: "#3d7cc9" }}
                className="border-inherit border py-1 px-4 rounded-md mt-4 text-white flex items-center ml-2"
              >
                Book Appointment
              </button>
            </div>
          </div> */}
          {/* <div>
            <div className="grid grid-cols-3  sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-9 mt-6">
              {menus.map((elem, num) => {
                if (num < number) {
                  return (
                    <>
                      <div className="w-full mb-6 px-2">
                        <div className="w-full flex justify-center mb-2">
                          <div
                            style={{
                              boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                            }}
                            className="w-20 h-20 border flex justify-center items-center"
                          >
                            <img className="w-16" src={elem.img} alt="" />
                          </div>
                        </div>
                        <p className="text-center">{elem.name}</p>
                      </div>
                    </>
                  );
                }
              })}
            </div>
          </div> */}
          {/* <div className="w-full flex justify-center">
            <button
              onClick={() => {
                number !== menus.length + 1
                  ? setNumber(menus.length + 1)
                  : handleWindowLoad();
              }}
              style={{ backgroundColor: "#48b95f" }}
              className="border-inherit border px-4 py-2 rounded-md mt-2 text-white"
            >
              {number !== menus.length + 1 ? "Read More" : "Read Less"}
            </button>
          </div> */}
        </div>
      </section>
    </>
  );
}
